import Vue from 'vue'
import store from "../store";
import Introduction from '../views/Introduction.vue'
import Authentication from '../views/Authentication.vue'
import Filtering from '../views/Filtering.vue'
import Debtor from '../views/Endpoints/Debtor.vue'
import DebtorsV4 from '../views/Endpoints/V4/DebtorsV4.vue'
import PurchaseInvoices from '../views/Endpoints/PurchaseInvoices.vue'
import PurchaseInvoiceLines from '../views/Endpoints/PurchaseInvoiceLines.vue'
import FinancialPost from '../views/Endpoints/FinancialPosts.vue'
import FinancialPostsV4 from '../views/Endpoints/V4/FinancialPostsV4.vue'
import FinancialAccounts from '../views/Endpoints/FinancialAccounts.vue'
import FinancialAccountsV4 from '../views/Endpoints/V4/FinancialAccountsV4.vue'
import Worksheets from '../views/Endpoints/Worksheets.vue'
import Worksheetsv4 from '../views/Endpoints/V4/WorksheetsV4.vue'
import Users from '../views/Endpoints/Users.vue'
import Creditors from '../views/Endpoints/Creditors.vue'
import PriceGroups from '../views/Endpoints/PriceGroups.vue'
import FitterHours from '../views/Endpoints/FitterHours.vue'
import FitterHoursV4 from '../views/Endpoints/V4/FitterHoursV4.vue'
import FitterCategories from '../views/Endpoints/FitterCategories.vue'
import ProjectGroups from '../views/Endpoints/ProjectGroups.vue'
import ClosedProjects from '../views/Endpoints/ClosedProjects.vue'
import InvoiceLines from '../views/Endpoints/InvoiceLines.vue'
import InvoiceLinesV4 from '../views/Endpoints/V4/InvoiceLinesV4.vue'
import Fitters from '../views/Endpoints/Fitters.vue'
import FittersV4 from '../views/Endpoints/V4/FittersV4.vue'
import SalaryPeriods from '../views/Endpoints/SalaryPeriods.vue'
import CalendarEvents from '../views/Endpoints/CalendarEvents.vue'
import CalendarEventsV4 from '../views/Endpoints/V4/CalendarEventsV4.vue'
import FinancialPostParentAccounts from '../views/Endpoints/FinancialPostParentAccounts.vue'
import Offers from '../views/Endpoints/Offers.vue'
import DepartmentDimensions from '../views/Endpoints/DepartmentDimensions.vue'
import Budgets from '../views/Endpoints/Budgets.vue'
import BudgetsV4 from '../views/Endpoints/V4/BudgetsV4.vue'
import CarrierDimensions from '../views/Endpoints/CarrierDimensions.vue'
import ProfitGroups from '../views/Endpoints/ProfitGroups.vue'
import PurposeDimensions from '../views/Endpoints/PurposeDimensions.vue'
import Invoices from '../views/Endpoints/Invoices.vue'
import InvoicesV4 from '../views/Endpoints/V4/InvoicesV4.vue'
import Response from '../views/Response.vue'
import Project from '../views/Endpoints/Project.vue'
import ProjectsV4 from '../views/Endpoints/V4/ProjectsV4.vue'
import Versionering from '../views/Versionering.vue'
import Customers from '../views/Admin/Customers.vue'
import SitesForCustomer from '../views/Admin/SitesForCustomer.vue'
import EndpointsForCustomer from '../views/Admin/EndpointsForCustomer.vue'
import SiteMetadataV4 from '../views/Endpoints/V4/SiteMetadataV4.vue'
import RolesV4 from '../views/Endpoints/V4/RolesV4.vue'
import CreditorsV4 from '../views/Endpoints/V4/CreditorsV4.vue'
import QAV4 from '../views/Endpoints/V4/QAV4.vue'
import AssociatedPeopleV4 from '../views/Endpoints/V4/AssociatedPeopleV4.vue'
import DeletedEntitiesV4 from '../views/Endpoints/V4/DeletedEntitiesV4.vue'
import OffersV4 from '../views/Endpoints/V4/OffersV4.vue'
import ProjectBudgetsV4 from '../views/Endpoints/V4/ProjectBudgetsV4.vue'
import Login from '../views/Login.vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/introduction',
  name: 'Introduction',
  component: Introduction,
},
{
  path: '/authentication',
  name: 'Authentication',
  component: Authentication,
},
{
  path: '/debtors',
  name: 'Debtor',
  component: Debtor,
},
{
  path: '/debtorsV4',
  name: 'DebtorsV4',
  component: DebtorsV4,
},
{
  path: '/budgets',
  name: 'Budgets',
  component: Budgets,
},
{
  path: '/budgetsv4',
  name: 'BudgetsV4',
  component: BudgetsV4,
},
{
  path: '/purchaseinvoices',
  name: 'PurchaseInvoices',
  component: PurchaseInvoices,
},
{
  path: '/purchaseinvoicelines',
  name: 'PurchaseInvoiceLines',
  component: PurchaseInvoiceLines,
},
{
  path: '/invoices',
  name: 'Invoices',
  component: Invoices,
},
{
  path: '/invoicesV4',
  name: 'InvoicesV4',
  component: InvoicesV4,
},
{
  path: '/pricegroups',
  name: 'PriceGroups',
  component: PriceGroups,
},
{
  path: '/profitgroups',
  name: 'ProfitGroups',
  component: ProfitGroups,
},
{
  path: '/financialpost',
  name: 'FinancialPost',
  component: FinancialPost,
},
{
  path: '/financialpostsV4',
  name: 'FinancialPostsV4',
  component: FinancialPostsV4,
},
{
  path: '/projects',
  name: 'Project',
  component: Project,
},
{
  path: '/projectsV4',
  name: 'ProjectsV4',
  component: ProjectsV4,
},
{
  path: '/worksheets',
  name: 'Worksheets',
  component: Worksheets,
},
{
  path: '/worksheetsv4',
  name: 'Worksheetsv4',
  component: Worksheetsv4,
},
{
  path: '/sitemetadatav4',
  name: 'SiteMetadataV4',
  component: SiteMetadataV4,
},
{
  path: '/rolesv4',
  name: 'RolesV4',
  component: RolesV4,
},
{
  path: '/qav4',
  name: 'QAV4',
  component: QAV4,
},
{
  path: '/associatedpeoplev4',
  name: 'AssociatedPeopleV4',
  component: AssociatedPeopleV4,
},
{
  path: '/deletedentitiesv4',
  name: 'DeletedEntitiesV4',
  component: DeletedEntitiesV4,
},
{
  path: '/offersv4',
  name: 'OffersV4',
  component: OffersV4,
},
{
  path: '/projectbudgetsv4',
  name: 'ProjectBudgetsV4',
  component: ProjectBudgetsV4,
},
{
  path: '/users',
  name: 'Users',
  component: Users,
},
{
  path: '/calendarevents',
  name: 'CalendarEvents',
  component: CalendarEvents,
},
{
  path: '/calendareventsv4',
  name: 'CalendarEventsV4',
  component: CalendarEventsV4,
},
{
  path: '/financialaccounts',
  name: 'FinancialAccounts',
  component: FinancialAccounts,
},
{
  path: '/financialaccountsv4',
  name: 'FinancialAccountsV4',
  component: FinancialAccountsV4,
},
{
  path: '/creditors',
  name: 'Creditors',
  component: Creditors,
},
{
  path: '/fitterhours',
  name: 'FitterHours',
  component: FitterHours,
},
{
  path: '/fitterhoursv4',
  name: 'FitterHoursV4',
  component: FitterHoursV4,
},
{
  path: '/creditorsv4',
  name: 'CreditorsV4',
  component: CreditorsV4,
},
{
  path: '/fittercategories',
  name: 'FitterCategories',
  component: FitterCategories,
},
{
  path: '/projectgroups',
  name: 'ProjectGroups',
  component: ProjectGroups,
},
{
  path: '/closedprojects',
  name: 'ClosedProjects',
  component: ClosedProjects,
},
{
  path: '/invoicelines',
  name: 'InvoiceLines',
  component: InvoiceLines,
},
{
  path: '/invoiceLinesV4',
  name: 'InvoiceLinesV4',
  component: InvoiceLinesV4,
},
{
  path: '/fitters',
  name: 'Fitters',
  component: Fitters,
},
{
  path: '/fittersv4',
  name: 'FittersV4',
  component: FittersV4,
},
{
  path: '/salaryperiods',
  name: 'SalaryPeriods',
  component: SalaryPeriods,
},
{
  path: '/financialpostparentaccounts',
  name: 'FinancialPostParentAccounts',
  component: FinancialPostParentAccounts,
},
{
  path: '/offers',
  name: 'Offers',
  component: Offers,
},
{
  path: '/departmentdimensions',
  name: 'DepartmentDimensions',
  component: DepartmentDimensions,
},
{
  path: '/carrierdimensions',
  name: 'CarrierDimensions',
  component: CarrierDimensions,
},
{
  path: '/purposedimensions',
  name: 'PurposeDimensions',
  component: PurposeDimensions,
},
{
  path: '/filtering',
  name: 'Filtering',
  component: Filtering,
},
{
  path: '/versioning',
  name: 'Versionering',
  component: Versionering,
},
{
  path: '/response',
  name: 'Response',
  component: Response,
},
{
  path: '/customers',
  name: 'Customers',
  meta: { requiresAuth: true },
  component: Customers,
},
{
  path: '/customers/:id',
  component: SitesForCustomer
},
{
  path: '/customers/:id/site/:siteId',
  component: EndpointsForCustomer
},
{
  path: '',
  component: Introduction
},
{
  path: '/login',
  component: Login,
  name: 'Login',
  meta: { guest: true },
},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router
